// Kept out of ./index.js, which runs a localStorage cleanup on import.

import {situationResponse} from '../../../../utils/models/v4AlarmSituation';
import {usesAlarmSituations} from '../../functions';

export function listResponseOf(situation, user) {
    if (!usesAlarmSituations(user)) return null;
    if (!situation?.root?.get?.('v4')) return null;
    const response = situationResponse(situation);
    return response.requestCount ? response : null;
}

export function situationMembers(situation) {
    if (!situation) return [];
    const seen = new Set();
    return [situation.root, ...(situation.requests || []).map((r) => r.alarm)].filter((alarm) => {
        if (!alarm) return false;
        const id = String(alarm.get('id'));
        if (seen.has(id)) return false;
        seen.add(id);
        return true;
    });
}

// wasNotified marks what it is asked about, so ask every member (no short-circuit).
export function situationNeedsAttention(situation, wasNotified) {
    const seen = situationMembers(situation).map((alarm) => wasNotified(alarm));
    return seen.some((notified) => !notified) && !!situation?.isOpen;
}
